import React, { useState, useEffect } from 'react';
import { Edit2, Save, X, RefreshCw, AlertCircle, FileText, Trash2, CheckCircle, Upload, Menu } from 'lucide-react';
import { FiDownload } from "react-icons/fi";
import NavBar from '../../../../component/b2b/navBar/b2bNavBar';
import Sidebar from '../../../../component/b2b/sideBar/b2bSideBar';
import { useMyContext } from '../../../../context/MyContext';
import { Base_Url, fetchUser, b2bsetprice, getRetailerPrice } from '../../../../config/config';
import RateCsvUplod from '../../Admin/SetRate/component/ratecsvuplaod'
const B2BSetRate = () => {
    const [activeTab, setActiveTab] = useState("customized");
    const token = localStorage.getItem('token');
    const cus_id = localStorage.getItem('cus_id');
    const { isDarkMode, isToggleSidebar } = useMyContext();
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [success, setSuccess] = useState(null);
    const [dataLoaded, setDataLoaded] = useState(false)
    const [editingCell, setEditingCell] = useState(null);
    const [editValue, setEditValue] = useState('');
    const [saving, setSaving] = useState(false);
// const [retailersLoaded, setRetailersLoaded] = useState(false);
    // Form state
    const [selectedRetailer, setSelectedRetailer] = useState('');
    const [selectedCourier, setSelectedCourier] = useState('');
    const [zonePricing, setZonePricing] = useState({});
    const [vasPricing, setVasPricing] = useState([]);
    const [showVasModal, setShowVasModal] = useState(false);

    // Dropdown options
    const [retailers, setRetailers] = useState([]);

    const courierPartners = [
        { id: 'delhivery', name: 'Delhivery' },
        { id: 'movin', name: 'movin' },
        { id: 'gati', name: 'gati' },
    ];

    const zones = ['n1', 'n2', 'n3', 'n4', 'c1', 'c2', 'w1', 'w2', 's1', 's2', 's3', 's4', 'e1', 'e2', 'ne1', 'ne2'];
    const zoneLabels = {
        n1: 'N1', n2: 'N2', n3: 'N3', n4: 'N4',
        c1: 'C1', c2: 'C2',
        w1: 'W1', w2: 'W2',
        s1: 'S1', s2: 'S2', s3: 'S3', s4: 'S4',
        e1: 'E1', e2: 'E2',
        ne1: 'NE1', ne2: 'NE2'
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab);
    };

    useEffect(() => {
        initializeDefaultPricing();
        initializeDefaultVAS();
        fetchRetailers();
    }, []);

    const fetchRetailers = async () => {
        const url = Base_Url + fetchUser;
        setLoading(true);
        try {
            const response = await fetch(url, {
                method: 'GET',
                headers: {
                    token: token,
                    cus_id: cus_id,
                    'Content-Type': 'application/json'
                }
            });
            const data = await response.json();
            if (data.status === "success") {
                const transformedData = data.data.map(user => {
                    const capitalizedName = user.name.charAt(0).toUpperCase() + user.name.slice(1);
                    return {
                        value: user.id,
                        label: `${capitalizedName} (${user.id})`,
                        id: user.id,
                        name: capitalizedName
                    };
                });
                setRetailers(transformedData);
            } else {
                setError(`Error: ${data.message} ${data.code ? `(Code: ${data.code})` : ''}`);
            }
        } catch (error) {
            setError(`Error fetching retailers: ${error.message}`);
        } finally {
            setLoading(false);
        }
    };

    const initializeDefaultPricing = () => {
        const defaultPricing = {};
        zones.forEach(fromZone => {
            defaultPricing[fromZone] = {};
            zones.forEach(toZone => {
                defaultPricing[fromZone][toZone] = '0';
            });
        });
        setZonePricing(defaultPricing);
    };

    const initializeDefaultVAS = () => {
        setVasPricing([
            {
                charge_key: 'cod_charge',
                label: 'COD Collection Fee',
                charge_type: 'percent',
                condition_value: 'invoice',
                value: '2.5',
                min_value: '20.00',
                max_value: '200.00',
                is_active: true
            },
            {
                charge_key: 'insurance',
                label: 'Insurance',
                charge_type: 'percent',
                condition_value: 'subtotal',
                value: '0.5',
                min_value: '',
                max_value: '',
                is_active: true
            },
            {
                charge_key: 'handling_fee',
                label: 'Handling Fee',
                charge_type: 'fixed',
                condition_value: 'base',
                value: '15.00',
                min_value: '',
                max_value: '',
                is_active: false
            }
        ]);
    };

    const fetchRetailerPrice = async (retailerId, courierPartner) => {
        setLoading(true);
        setError(null);
        setDataLoaded(false); // RESET DATA LOADED STATE
        try {
            const apiUrl = Base_Url + getRetailerPrice;
            const requestBody = {
                retailer_id: retailerId,
                partner: courierPartner
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'cus_id': cus_id,
                    'token': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();
            if (response.ok && data.status === 'success') {
                // Parse and set zone pricing
                if (data.data.zone_pricing) {
                    const zonePricingData = JSON.parse(data.data.zone_pricing);
                    setZonePricing(zonePricingData);
                } else {
                    // If no zone pricing in response, initialize default
                    initializeDefaultPricing();
                }

                // Parse and set VAS pricing
                if (data.data.vas_pricing) {
                    const vasPricingData = JSON.parse(data.data.vas_pricing);
                    setVasPricing(vasPricingData);
                } else {
                    // If no VAS pricing in response, initialize default
                    initializeDefaultVAS();
                }

                setDataLoaded(true); // MARK DATA AS LOADED
                setSuccess('Pricing data loaded successfully!');
                setTimeout(() => setSuccess(null), 1000);
            } else {
                setError(`Error: ${data.message || 'Failed to fetch pricing'} ${data.code ? `(Code: ${data.code})` : ''}`);
                // Don't set dataLoaded to true on error
            }
        } catch (error) {
            setError(`Error fetching pricing: ${error.message}`);
            // Don't set dataLoaded to true on error
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        let timeoutId;
        if (selectedRetailer && selectedCourier) {
            // Reset data loaded state when selections change
            setDataLoaded(false);

            // Wait 2 seconds after both are selected
            timeoutId = setTimeout(() => {
                fetchRetailerPrice(selectedRetailer, selectedCourier);
            }, 2000);
        } else {
            // Reset if selections are cleared
            setDataLoaded(false);
        }

        // Cleanup timeout if user changes selection before 2 seconds
        return () => {
            if (timeoutId) {
                clearTimeout(timeoutId);
            }
        };
    }, [selectedRetailer, selectedCourier]);

    const setPricing = async () => {
        if (!selectedRetailer) {
            setError('Please select a retailer');
            return;
        }
        if (!selectedCourier) {
            setError('Please select a courier partner');
            return;
        }

        setSaving(true);
        setError(null);
        setSuccess(null);

        try {
            const apiUrl = Base_Url + b2bsetprice;
            const requestBody = {
                retailer_id: selectedRetailer,
                courier_partner: selectedCourier,
                zone_pricing: zonePricing,
                vas_pricing: vasPricing
            };

            const response = await fetch(apiUrl, {
                method: 'POST',
                headers: {
                    'cus_id': cus_id,
                    'token': token,
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(requestBody)
            });

            const data = await response.json();

            if (response.ok && data.status === 'success') {
                setSuccess('Pricing updated successfully!');
                setTimeout(() => setSuccess(null), 3000);
            } else {
                setError(`Error: ${data.message || 'Failed to update pricing'} ${data.code ? `(Code: ${data.code})` : ''}`);
            }
        } catch (error) {
            setError(`Error updating pricing: ${error.message}`);
        } finally {
            setSaving(false);
        }
    };

    const handleCellEdit = (fromZone, toZone, currentValue) => {
        setEditingCell(`${fromZone}-${toZone}`);
        setEditValue(currentValue);
    };

    const handleSaveEdit = (fromZone, toZone) => {
        if (editValue === '' || isNaN(parseFloat(editValue))) {
            setError('Please enter a valid number');
            return;
        }

        const updatedPricing = { ...zonePricing };
        updatedPricing[fromZone][toZone] = editValue;
        setZonePricing(updatedPricing);

        setEditingCell(null);
        setEditValue('');
        setError(null);
    };

    const handleCancelEdit = () => {
        setEditingCell(null);
        setEditValue('');
    };

    const updateVasField = (index, field, value) => {
        const updated = [...vasPricing];
        updated[index][field] = value;
        setVasPricing(updated);
    };

    // const addVasCharge = () => {
    //     setVasPricing([...vasPricing, {
    //         charge_key: '',
    //         label: '',
    //         charge_type: 'fixed',
    //         condition_value: 'base',
    //         value: '',
    //         min_value: '',
    //         max_value: '',
    //         is_active: true
    //     }]);
    // };


    const renderRateTable = () => {
        // CONDITIONAL RENDERING LOGIC
        if (!selectedRetailer || !selectedCourier) {
            return (
                <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <AlertCircle className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                    <h3 className="text-xl font-semibold text-gray-700 mb-2">
                        No Selection Made
                    </h3>
                    <p className="text-gray-500">
                        Please select both a retailer and courier partner to view pricing matrix
                    </p>
                </div>
            );
        }

        if (loading && !dataLoaded) {
            return (
                <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <RefreshCw className="w-16 h-16 text-blue-600 mx-auto mb-4 animate-spin" />
                    <h3 className="text-xl font-semibold text-gray-700 mb-2">
                        Loading Pricing Data...
                    </h3>
                    <p className="text-gray-500">
                        Fetching pricing information for {courierPartners.find(c => c.id === selectedCourier)?.name}
                    </p>
                </div>
            );
        }

        if (!dataLoaded) {
            return (
                <div className="bg-white rounded-lg shadow-lg p-8 text-center">
                    <RefreshCw className="w-16 h-16 text-gray-400 mx-auto mb-4" />
                    <h3 className="text-xl font-semibold text-gray-700 mb-2">
                        Waiting for Data...
                    </h3>
                    <p className="text-gray-500">
                        Please wait while we load the pricing data
                    </p>
                </div>
            );
        }

        // RENDER THE ACTUAL TABLE ONLY WHEN DATA IS LOADED
        return (
            <div className="bg-white rounded-lg shadow-lg overflow-hidden">
                <div className="bg-gradient-to-r from-blue-600 to-blue-700 px-3 sm:px-6 py-3 sm:py-4">
                    <div className="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                        <div>
                            <h3 className="text-lg sm:text-xl font-bold text-white">Zone Pricing Matrix</h3>
                            <p className="text-blue-100 text-xs sm:text-sm mt-1">
                                {selectedRetailer && selectedCourier
                                    ? `${courierPartners.find(c => c.id === selectedCourier)?.name} - Retailer ${selectedRetailer}`
                                    : 'Select retailer and courier to configure pricing'}
                            </p>
                        </div>
                        <div className="flex flex-wrap gap-2">
                            {/* <button
                                onClick={loadSampleData}
                                className="bg-blue-500 text-white px-3 sm:px-4 py-2 rounded-lg hover:bg-blue-400 transition-colors text-xs sm:text-sm font-medium flex items-center gap-2"
                            >
                                <Upload size={14} className="sm:w-4 sm:h-4" />
                                <span className="hidden xs:inline">Load Sample</span>
                                <span className="xs:hidden">Sample</span>
                            </button> */}
                            <button
                                onClick={() => setShowVasModal(true)}
                                className="bg-white text-blue-600 px-3 sm:px-4 py-2 rounded-lg hover:bg-blue-50 transition-colors text-xs sm:text-sm font-medium whitespace-nowrap"
                            >
                                <span className="hidden xs:inline">Manage VAS</span>
                                <span className="xs:hidden">VAS</span>
                            </button>
                        </div>
                    </div>
                </div>

                <div className="overflow-x-auto -mx-4 sm:mx-0">
                    <div className="inline-block min-w-full align-middle">
                        <table className="min-w-full">
                            <thead>
                                <tr className="bg-gray-50">
                                    <th className="px-2 sm:px-4 py-2 sm:py-3 text-left text-xs sm:text-sm font-semibold text-gray-700 border-b sticky left-0 bg-gray-50 z-10 min-w-[60px] sm:min-w-[80px]">
                                        From/To
                                    </th>
                                    {zones.map(zone => (
                                        <th key={zone} className="px-1 sm:px-3 py-2 sm:py-3 text-center text-[10px] sm:text-xs font-medium text-gray-700 border-b min-w-[50px] sm:min-w-[80px]">
                                            {zoneLabels[zone]}
                                        </th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {zones.map(fromZone => (
                                    <tr key={fromZone} className="hover:bg-gray-50 transition-colors">
                                        <td className="px-2 sm:px-4 py-2 sm:py-3 text-xs sm:text-sm font-medium text-gray-700 bg-gray-50 border-r sticky left-0 z-10">
                                            {zoneLabels[fromZone]}
                                        </td>
                                        {zones.map(toZone => {
                                            const rate = zonePricing[fromZone]?.[toZone] || '0';
                                            const cellId = `${fromZone}-${toZone}`;
                                            const isEditing = editingCell === cellId;

                                            return (
                                                <td key={toZone} className="px-1 sm:px-2 py-1 sm:py-2 text-center border-b border-r">
                                                    {isEditing ? (
                                                        <div className="flex items-center gap-1 justify-center">
                                                            <input
                                                                type="number"
                                                                value={editValue}
                                                                onChange={(e) => setEditValue(e.target.value)}
                                                                className="w-12 sm:w-16 px-1 sm:px-2 py-1 text-xs sm:text-sm border rounded focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                step="0.1"
                                                                autoFocus
                                                            />
                                                            <button
                                                                onClick={() => handleSaveEdit(fromZone, toZone)}
                                                                className="p-0.5 sm:p-1 text-green-600 hover:text-green-700"
                                                            >
                                                                <Save size={12} className="sm:w-3.5 sm:h-3.5" />
                                                            </button>
                                                            <button
                                                                onClick={handleCancelEdit}
                                                                className="p-0.5 sm:p-1 text-red-600 hover:text-red-700"
                                                            >
                                                                <X size={12} className="sm:w-3.5 sm:h-3.5" />
                                                            </button>
                                                        </div>
                                                    ) : (
                                                        <div
                                                            className="group flex items-center justify-center gap-1 py-1 cursor-pointer hover:bg-blue-50 rounded"
                                                            onClick={() => handleCellEdit(fromZone, toZone, rate)}
                                                        >
                                                            <span className="text-xs sm:text-sm font-medium">₹{rate}</span>
                                                            <Edit2 size={10} className="hidden sm:block sm:w-3 sm:h-3 opacity-0 group-hover:opacity-50 text-blue-600 transition-opacity" />
                                                        </div>
                                                    )}
                                                </td>
                                            );
                                        })}
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        );
    };
    return (
        <>
            <div className={`h-screen flex flex-col overflow-hidden ${isDarkMode ? 'dark:bg-darkmodeColor' : 'bg-white'}`}>
                <div className="z-10">
                    <NavBar />
                </div>
                <div className="flex flex-1 overflow-hidden">
                    {isToggleSidebar && (
                        <div
                            className={`fixed z-20 h-full w-64 md:relative duration-300 bg-gray-200 dark:bg-darkmodeColor dark:text-white md:bg-transparent mt-4 md:w-64 md:z-20`}
                            style={
                                window.innerWidth < 768
                                    ? { top: '113px', height: 'calc(100vh - 115px)', overflowY: 'auto' }
                                    : {}
                            }
                        >
                            <Sidebar />
                        </div>
                    )}

                    <div className="flex-1 overflow-y-auto bg-white py-2 sm:py-4 lg:py-6">
                        <div className="max-w-7xl mx-auto px-3 sm:px-2 lg:px-6">
                            <div className="mb-6 sm:mb-8 flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between">
                                {/* LEFT: Title */}
                                <div className="px-2">
                                    <h1 className="text-lg sm:text-xl font-semibold text-gray-900">
                                        B2B Rate Card Management
                                    </h1>
                                    <p className="text-xs sm:text-sm text-gray-600 mt-1 max-w-xl">
                                        Configure shipping rates and VAS pricing for different retailers and courier partners
                                    </p>
                                </div>

                                {/* RIGHT: Tabs */}
                                <div className="px-2">
                                    <div className="inline-flex bg-gray-100 rounded-xl p-1 shadow-sm">
                                        <button
                                            onClick={() => handleTabClick("customized")}
                                            className={`px-4 py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200
          ${activeTab === "customized"
                                                    ? "bg-white text-blue-600 shadow"
                                                    : "text-gray-600 hover:text-gray-800"
                                                }`}
                                        >
                                            Customized Ratecard
                                        </button>

                                        <button
                                            onClick={() => handleTabClick("csv")}
                                            className={`px-4 py-1.5 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200
          ${activeTab === "csv"
                                                    ? "bg-white text-blue-600 shadow"
                                                    : "text-gray-600 hover:text-gray-800"
                                                }`}
                                        >
                                            CSV Upload
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {activeTab === "customized" && (
                                <div>
                                    <div className="bg-white rounded-lg shadow-md p-3 sm:p-2 lg:p-4 mb-4 sm:mb-6 mt-4">
                                        <div className="grid grid-cols-1 sm:grid-cols-3 gap-3 items-end">
                                            {/* Retailer */}
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-medium text-gray-700">
                                                    Select Retailer <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={selectedRetailer}
                                                    onChange={(e) => setSelectedRetailer(e.target.value)}
                                                    disabled={loading}
                                                    className="h-[36px] px-3 text-xs border border-gray-300 rounded-lg 
      focus:outline-none focus:ring-2 focus:ring-indigo-500
      disabled:bg-gray-100 disabled:cursor-not-allowed"
                                                >
                                                    <option value="">
                                                        {loading ? "Loading retailers..." : "-- Select Retailer --"}
                                                    </option>
                                                    {retailers.map((retailer) => (
                                                        <option key={retailer.value} value={retailer.value}>
                                                            {retailer.label}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Courier Partner */}
                                            <div className="flex flex-col gap-1">
                                                <label className="text-xs font-medium text-gray-700">
                                                    Select Courier Partner <span className="text-red-500">*</span>
                                                </label>
                                                <select
                                                    value={selectedCourier}
                                                    onChange={(e) => setSelectedCourier(e.target.value)}
                                                    className="h-[36px] px-3 text-xs border border-gray-300 rounded-lg 
      focus:outline-none focus:ring-2 focus:ring-indigo-500"
                                                >
                                                    <option value="">-- Select Courier Partner --</option>
                                                    {courierPartners.map((courier) => (
                                                        <option key={courier.id} value={courier.id}>
                                                            {courier.name}
                                                        </option>
                                                    ))}
                                                </select>
                                            </div>

                                            {/* Save Button */}
                                            <button
                                                onClick={setPricing}
                                                disabled={saving || !selectedRetailer || !selectedCourier|| !dataLoaded  }
                                                className="h-[36px] px-4 bg-gradient-to-r from-indigo-600 to-purple-600 
    text-white rounded-xl text-xs font-semibold
    flex items-center justify-center gap-2
    disabled:opacity-60 disabled:cursor-not-allowed"
                                            >
                                                {saving ? (
                                                    <>
                                                        <RefreshCw size={14} className="animate-spin" />
                                                        Saving...
                                                    </>
                                                ) : (
                                                    <>
                                                        <Save size={14} />
                                                        Save Pricing
                                                    </>
                                                )}
                                            </button>
                                        </div>

                                    </div>





                                    {success && (
                                        <div className="mb-4 sm:mb-6 bg-green-50 border border-green-200 rounded-lg p-3 sm:p-4">
                                            <div className="flex items-center gap-2">
                                                <CheckCircle className="text-green-600 flex-shrink-0" size={18} />
                                                <p className="text-green-800 font-medium text-sm sm:text-base">{success}</p>
                                            </div>
                                        </div>
                                    )}


                                    {error && (
                                        <div className="mb-4 sm:mb-6 bg-red-50 border border-red-200 rounded-lg p-3 sm:p-4">
                                            <div className="flex items-center gap-2">
                                                <AlertCircle className="text-red-600 flex-shrink-0" size={18} />
                                                <p className="text-red-800 font-medium text-sm sm:text-base">{error}</p>
                                            </div>
                                        </div>
                                    )}

                                    {renderRateTable()}
                                    {showVasModal && (
                                        <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-2 sm:p-4">
                                            <div className="bg-white rounded-lg shadow-xl w-full max-w-4xl max-h-[90vh] overflow-y-auto">
                                                <div className="sticky top-0 bg-gradient-to-r from-blue-600 to-blue-700 px-4 sm:px-6 py-3 sm:py-4 flex items-center justify-between z-10">
                                                    <h3 className="text-base sm:text-xl font-bold text-white">
                                                        VAS Pricing Configuration
                                                    </h3>
                                                    <button
                                                        onClick={() => setShowVasModal(false)}
                                                        className="text-white hover:text-gray-200"
                                                    >
                                                        <X size={20} className="sm:w-6 sm:h-6" />
                                                    </button>
                                                </div>

                                                <div className="p-3 sm:p-4 lg:p-6">
                                                    <div className="space-y-3 sm:space-y-4">
                                                        {vasPricing.map((vas, index) => (
                                                            <div key={index} className="border rounded-lg p-3 sm:p-4 bg-gray-50">
                                                                <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Charge Key
                                                                        </label>

                                                                        <input
                                                                            type="text"
                                                                            value={vas.charge_key}
                                                                            onChange={(e) => updateVasField(index, 'charge_key', e.target.value)}
                                                                            disabled={[
                                                                                "processing",
                                                                                "fsc",
                                                                                "rov_owner",
                                                                                "rov_carrier",
                                                                                "handling",
                                                                                "oda",
                                                                                "demurrage",
                                                                                "csd_delivery",
                                                                                "re_attempt",
                                                                                "pickup_charge",
                                                                                "to_pay",
                                                                                "cheque_handling",
                                                                                "cash_handling",
                                                                                "green_tax",
                                                                                "min_lr_charge",
                                                                                "gst"
                                                                            ].includes(vas.charge_key)}

                                                                            className={`w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg 
      focus:outline-none focus:ring-2 focus:ring-blue-500 
      ${[
                                                                                    "processing",
                                                                                    "fsc",
                                                                                    "rov_owner",
                                                                                    "rov_carrier",
                                                                                    "handling",
                                                                                    "oda",
                                                                                    "demurrage",
                                                                                    "csd_delivery",
                                                                                    "re_attempt",
                                                                                    "pickup_charge",
                                                                                    "to_pay",
                                                                                    "cheque_handling",
                                                                                    "cash_handling",
                                                                                    "green_tax",
                                                                                    "min_lr_charge",
                                                                                    "gst"
                                                                                ].includes(vas.charge_key)
                                                                                    ? 'bg-gray-200 cursor-not-allowed'
                                                                                    : ''
                                                                                }`}
                                                                            placeholder="e.g., cod_charge"
                                                                        />
                                                                    </div>

                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Label
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={vas.label}
                                                                            onChange={(e) => updateVasField(index, 'label', e.target.value)}
                                                                            className="w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            placeholder="e.g., COD Collection Fee"
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Charge Type
                                                                        </label>
                                                                        <select
                                                                            value={vas.charge_type}
                                                                            onChange={(e) => updateVasField(index, 'charge_type', e.target.value)}
                                                                            className="w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                        >
                                                                            <option value="fixed">Fixed</option>
                                                                            <option value="percent">Percent</option>
                                                                            <option value="per_kg">Per KG</option>
                                                                        </select>
                                                                    </div>
                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Condition Value
                                                                        </label>
                                                                        <select
                                                                            value={vas.condition_value}
                                                                            onChange={(e) => updateVasField(index, 'condition_value', e.target.value)}
                                                                            className="w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                        >
                                                                            <option value="LR">LR</option>
                                                                            <option value="base">Base</option>
                                                                            <option value="invoice">Invoice</option>
                                                                            <option value="subtotal">Subtotal</option>
                                                                            <option value="weight">Weight</option>
                                                                        </select>
                                                                    </div>
                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Value
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={vas.value}
                                                                            onChange={(e) => updateVasField(index, 'value', e.target.value)}
                                                                            className="w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            placeholder="e.g., 2.5 or 15.00"
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Min Value
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={vas.min_value || ''}
                                                                            onChange={(e) => updateVasField(index, 'min_value', e.target.value || null)}
                                                                            className="w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            placeholder="Optional"
                                                                        />
                                                                    </div>
                                                                    <div>
                                                                        <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-1">
                                                                            Max Value
                                                                        </label>
                                                                        <input
                                                                            type="text"
                                                                            value={vas.max_value || ''}
                                                                            onChange={(e) => updateVasField(index, 'max_value', e.target.value || null)}
                                                                            className="w-full px-2 sm:px-3 py-1.5 sm:py-2 text-sm border rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                                                                            placeholder="Optional"
                                                                        />
                                                                    </div>
                                                                    <div className="sm:col-span-2 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                                                                        <label className="flex items-center gap-2">
                                                                            <input
                                                                                type="checkbox"
                                                                                checked={vas.is_active}
                                                                                onChange={(e) => updateVasField(index, 'is_active', e.target.checked)}
                                                                                className="w-4 h-4 text-blue-600 rounded"
                                                                            />
                                                                            <span className="text-xs sm:text-sm font-medium text-gray-700">Active</span>
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        ))}
                                                    </div>

                                                    <div className="mt-4 sm:mt-6 flex gap-2 sm:gap-3 justify-end">
                                                        <button
                                                            onClick={() => setShowVasModal(false)}
                                                            className="w-full sm:w-auto px-4 py-2 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors text-sm sm:text-base"
                                                        >
                                                            Close
                                                        </button>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    )}
                                </div>
                            )}

                            {activeTab === "csv" && (
                                <RateCsvUplod />
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default B2BSetRate;